import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../constants';
import { useAuth } from '../useAuth';
import dashboardController from '../../services/api/dashboardController';
import { TeamMember } from '../../services/api/teamController';

type AuthLike = { tokens?: { idToken?: { jwtToken?: string } } };

export const useSalesPlgMembers = (enabled: boolean = true) => {
  const auth = useAuth();
  const authToken = (auth as AuthLike)?.tokens?.idToken?.jwtToken ?? '';

  return useQuery<TeamMember[]>({
    queryKey: QUERY_KEYS.SALES_PLG_MEMBERS,
    queryFn: async () =>
      (await dashboardController.getSalesMembers(authToken)).data.members,
    enabled: enabled && Boolean(authToken),
    refetchOnWindowFocus: false,
  });
};
